exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LoginPage{display:flex;flex-grow:1;align-items:center;justify-content:center;height:100%;overflow:hidden;background-color:#9b3fb9;flex-direction:column}.LoginPage h1,.LoginPage h2{color:#fff;text-shadow:1px 1px 1px rgba(0,0,0,.2);font-weight:400;text-align:center}.LoginPage .LoginForm{margin:auto;min-width:320px;display:flex;flex-direction:column;background-color:#fff;border-radius:8px;padding:10px;margin-bottom:100px}.LoginPage .LoginForm input{display:flex;flex-grow:1;margin:16px}.LoginPage .LoginForm input[type=submit]{color:#f9682f;background-color:#fff;border:0;text-align:right}.LoginPage .LoginForm input[type=submit][disabled]{opacity:.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/login/style.scss
// module id = 291
// module chunks = 0